import React, {useCallback} from "react";
import {UserLocalStorageApi} from "../../../../../apis/local-storage/UserLocalStorageApi";

export const customLinksKey = 'customAceLinks';

export type CustomAceLink = {
    id: string;
    name: string;
    url: string;
}

const UseLiveCustomLinks = () => {

    const [links, setLinks] = React.useState<Array<CustomAceLink>>([]);
    const [loading, setLoading] = React.useState(true);


    const saveLinksToStore = useCallback(saveLinks => {
        UserLocalStorageApi.setItem({key: customLinksKey, value: saveLinks}).catch(() => {
            // Ignore errors
        });
    }, []);

    React.useEffect(() => {
        const loadLinksFromRemoteStorage = () => {
            UserLocalStorageApi.getItem({key: customLinksKey}).then(remoteLinks => {
                const loadedLinks: CustomAceLink[] = remoteLinks.item ?? [];

                const localLinks = localStorage.getItem(customLinksKey) ? JSON.parse(localStorage.getItem(customLinksKey)) : [];
                if (localLinks?.length > 0) {
                    for (const link of localLinks) {
                        if (!loadedLinks.find(l => l.id === link.id)) {
                            loadedLinks.push(link);
                        }
                    }
                    localStorage.removeItem(customLinksKey);
                    saveLinksToStore(loadedLinks);
                }
                
                setLinks(loadedLinks);
                setLoading(false);
            }).catch(() => {
                setLoading(false);
            });
        }

        loadLinksFromRemoteStorage();

        setLoading(false);
    }, [saveLinksToStore]);


    return {
        links,
        setLinks: (newLinks: Array<CustomAceLink>) => {
            setLinks(newLinks);
            saveLinksToStore(newLinks);
        },
        loading
    }
}

export default UseLiveCustomLinks;
